export default ($stateProvider) => {
  $stateProvider
    .state('forgot-password', {
      url: `${location.pathname}forgot-password`,
      template: '<nets-forgot-password></nets-forgot-password>',
    });
};
